import { SHIP_POPUP_TEXT } from '../../constants/ship.logic';

/**
 * C-4 열 머리(P1-170) — 행 구조(좌측 머리 · 4칸 흐름 · 조치)와 같은 폭 배치.
 * 각 칸 안에 같은 제목이 이미 있으므로 화면 낭독에서는 건너뛴다.
 */
export function ShipColumnHeader() {
  const c = SHIP_POPUP_TEXT.columns;
  return (
    <div
      aria-hidden="true"
      className="flex items-start gap-05 border-b border-hairline border-border px-05 pb-02"
      style={{ fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface-2)' }}
    >
      <span className="w-48 shrink-0">{c.head}</span>
      <span className="flex min-w-0 flex-1 gap-03">
        {[c.request, c.reply, c.notice, c.receipt].map(t => (
          <span key={t} className="min-w-0 flex-1">{t}</span>
        ))}
      </span>
      <span className="min-w-24 text-right">{c.action}</span>
    </div>
  );
}
